import genderModel from "./gender";
import levelModel from "./level";
import ranngeModel from "./rannge";
import imageModel from "./image";
import discountModel from "./discount";
import equipmentModel from "./equipment";
import pricesModel from "./prices";

export default class {

  constructor() {
    this.example = "";
    this.id = 0;
    this.translations = {};
    this.gender = {};
    this.level = {};
    this.rannge = {};
    this.image = {};
    this.discounts = [];
    this.type = {};
    this.prices = {};
    this.productEquipments = [];
    this.tvaRate = 0;

    // Require tva rate
    this.price = 0;
    this.discountedPrice = 0;
  }

  hydrate(data) {
    if (void 0 !== data.example) this.example = data.example;
    if (void 0 !== data.id) this.id = data.id;
    if (void 0 !== data.translations) this.translations = data.translations;
    if (void 0 !== data.tvaRate) this.tvaRate = data.tvaRate;

    if (data.gender) {
      const _g = new genderModel();
      _g.hydrate(data.gender);
      this.gender = _g;
    }

    if (data.level) {
      const _l = new levelModel();
      _l.hydrate(data.level);
      this.level = _l;
    }

    if (data.rannge) {
      const _r = new ranngeModel();
      _r.hydrate(data.rannge);
      this.rannge = _r;
    }

    if (data.image) {
      const _i = new imageModel();
      _i.hydrate(data.image);
      this.image = _i;
    }

    if (data.discounts) {
      for(let d of data.discounts) {
        const _d = new discountModel();
        _d.hydrate(d);
        this.discounts.push(_d);
      }
    }

    if (data.prices) {
      const _p = new pricesModel();
      _p.hydrate(data.prices);
      this.prices = _p;
    }

    if (data.productEquipments) {
      for (let pe of data.productEquipments) {
        const _e = new equipmentModel();
        _e.hydrate(pe);

        // Add discount
        if (data.discounts) {
          _e.discounts = this.discounts;
        }
        this.productEquipments.push(_e);
      }
    }
  }
}
